module.exports = __webpack_public_path__ + "e566b26e5d8626c30bc2a6547cfbd05a.svg";